export default "__VITE_ASSET__Dth0_23E__"